export class Question {
    constructor(p_id, p_answerMode, p_answers, p_conditions)
    {
        this.id = p_id;
        this.answerMode = p_answerMode;
        this.answers = p_answers;
        this.conditions = p_conditions;
        this.canBeDisplayed = true;
    }
}